import { csrfInterceptor } from "@sazka/utils/http-clients/csrf-interceptor";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import axios, { type AxiosRequestConfig, type AxiosRequestHeaders } from "axios";

// serialize date to local time to keep correct date from calendar input
// We need to pass in second arg, so ts compiler doesn't complain
function dateTransformer(data: unknown, headers?: AxiosRequestHeaders) {
    if (data instanceof Date) {
        return DateTimeUtils.getLocalIsoString(data);
    }
    if (Array.isArray(data)) {
        return data.map((val) => dateTransformer(val, headers));
    }
    if (typeof data === "object" && data !== null) {
        return Object.fromEntries(Object.entries(data).map(([key, val]) => [key, dateTransformer(val, headers)]));
    }
    return data;
}

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: "/api/draw-games",
    transformRequest: [dateTransformer].concat(axios.defaults.transformRequest),
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const drawGamesHttpClient = axios.create(config);

/** Adding the request interceptors */
drawGamesHttpClient.interceptors.request.use(csrfInterceptor);

/** Adding the response interceptors */
drawGamesHttpClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        /** Do something with response error */
        return Promise.reject(error);
    }
);

export { drawGamesHttpClient };
